export default {
  veryBad: {
    id: 'review_funnel_rating_very_bad',
    defaultMessage: '1/5 - Very bad',
  },
  bad: {
    id: 'review_funnel_rating_bad',
    defaultMessage: '2/5 - Bad',
  },
  notGreat: {
    id: 'review_funnel_rating_not_great',
    defaultMessage: '3/5 - Not great',
  },
  good: {
    id: 'review_funnel_rating_good',
    defaultMessage: '4/5 - Good',
  },
  excellent: {
    id: 'review_funnel_rating_excellent',
    defaultMessage: '5/5 - Excellent',
  },
} as const
